module.exports = __webpack_public_path__ + "static/media/tba22-banner-figure.bd41065c.png";